import React from "react";

/**
 * Name -> React.lazy component for each interactive tool. A
 * `<div class="tool-slot" data-tool="NAME">` in a content page is filled from
 * here; a name that is not in the map renders nothing.
 *
 * Every tool runs in the browser only: no network calls, nothing stored on a
 * server.
 */
export const TOOLS = {
  payback: React.lazy(() => import("./payback/Payback")),
  receipt: React.lazy(() => import("./receipt/Receipt")),
  reminders: React.lazy(() => import("./reminders/Reminders")),
  pricecalc: React.lazy(() => import("./pricecalc/PriceCalc")),
  feechart: React.lazy(() => import("./feechart/FeeChart")),
  profit: React.lazy(() => import("./profit/Profit")),
  startup: React.lazy(() => import("./startup/Startup")),
  "startup-hi": React.lazy(() => import("./startup/StartupHi")),
  // The GST calculator (./gst/Gst) is built but deliberately NOT registered:
  // anything registered here ships as a public JS chunk. Add
  //   gst: React.lazy(() => import("./gst/Gst")),
  // when the owner releases the held GST pages (web/content-hold/README.md).
};
